import { useSyncExternalStore } from "react";
import { getIdentityStore } from "../session/identity";
import { ChatSession } from "./chat-session";

let session: ChatSession | undefined;
export function getChatSession(): ChatSession {
  session ??= new ChatSession(getIdentityStore().get());
  return session;
}

export function useChat() {
  const chat = getChatSession();
  const state = useSyncExternalStore(
    (listener) => chat.subscribe(listener),
    () => chat.state,
  );
  return { state, chat };
}
